export default __webpack_public_path__ + "static/media/eduact-logo.10cc2f16.svg";